import * as yup from 'yup'
import { parsePhoneNumberFromString } from 'libphonenumber-js'
import { REIMBURSEMENT_PERCENTAGE_MAX } from 'src/constants/partnerDriver/constants'

const DECIMAL_2DP_PATTERN = /^\d+(\.\d{1,2})?$/

export const partnerDriverProfileFormValidator = yup.object({
  firstName: yup.string().trim().required('First name is required'),
  lastName: yup.string().trim().required('Last name is required'),
  // The DTO only checks `IsString`, so a typo would be saved as-is without this.
  email: yup.string().trim().required('Email is required').email('Enter a valid email'),
  // Mirrors @IsPhoneNumber('US') — resolve the country explicitly, as BusinessProfileForm does,
  // so a fully-qualified non-US number is rejected too.
  phone: yup
    .string()
    .trim()
    .required('Phone is required')
    .test('is-us-phone', 'Enter a valid US phone number', (value) => {
      // Blank is `required`'s error; returning true here keeps it to one message per field.
      if (!value) {
        return true
      }

      const parsedPhoneNumber = parsePhoneNumberFromString(value, 'US')

      return Boolean(
        parsedPhoneNumber && parsedPhoneNumber.country === 'US' && parsedPhoneNumber.isValid(),
      )
    }),
  reimbursementAmount: yup
    .string()
    .trim()
    .test('amount', 'Enter an amount of 0 or more, up to 2 decimals', (value) => {
      if (!value) {
        return true
      }

      return DECIMAL_2DP_PATTERN.test(value)
    }),
  reimbursementPercentage: yup
    .string()
    .trim()
    .test('percentage', 'Enter a percentage from 0 to 99.99', (value) => {
      if (!value) {
        return true
      }

      if (!DECIMAL_2DP_PATTERN.test(value)) {
        return false
      }

      return Number(value) <= REIMBURSEMENT_PERCENTAGE_MAX
    }),
})
